import cookie from 'js-cookie';
import { useRouter } from 'next/router';
import axios from 'axios';

const ALLOW_ROUTES = ['/login', '/'];

const withAuth = (WrappedComponent) => (props) => {
  // checks whether we are on client / browser or server.
  if (typeof window !== 'undefined') {
    const Router = useRouter();
    // const liveAccess = useSelector((state) => state.user.liveAccess);

    const accessToken = cookie.get('token');

    if (!axios.defaults?.headers?.authorization && accessToken) {
      axios.defaults.headers.authorization = `Bearer ${accessToken}`;
    }

    if (!ALLOW_ROUTES.some((route) => route === Router.pathname)) {
      // If there is no access token we redirect to "/login" page.

      if (!accessToken) {
        Router.replace('/login');
      } else {
        return <WrappedComponent {...props} />;
      }
    } else {
      // If this is an accessToken we just render the component that was passed with all its props

      return <WrappedComponent {...props} />;
    }
  }

  // If we are on server, return null
  return null;
};

export default withAuth;
